// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-pro-stripe-payment-resume-modal .modal__container{
    padding: 30px 40px;
}

.baloa-pro-stripe-payment-resume-modal {
    text-align: center;
}

.baloa-pro-stripe-payment-resume-modal__container {
    text-align: center;
}

.baloa-pro-stripe-payment-resume-modal .hubicon-check_circle {
    font-size: 60px;
}

.baloa-pro-stripe-payment-resume-modal__title.baloa-headline-2{
    color: var(--new-green-color);
}

.baloa-pro-stripe-payment-resume-modal__greetings.baloa-names,
.baloa-pro-stripe-payment-resume-modal__message.baloa-names {
    font-weight: var(--font-regular);
    color: var(--new-primary-very-dark-color);
    margin-top: 32px;
}

.baloa-pro-stripe-payment-resume-modal__resume-container {
    border-radius: 8px;
    border: 1px solid var( --new-gray-background-color);
    margin-top: 43px;
}

.baloa-pro-stripe-payment-resume-modal__resume-container-title.baloa-names  {
    background: var(--black-color);
    color: var(--white-color);
    border: inherit;
    border-radius: 8px 8px 0 0;
    padding: 8px 0;
}

.baloa-pro-stripe-payment-resume-modal__resume-container-items {
    padding: 24px;
}

.baloa-pro-stripe-payment-resume-modal__resume-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 19px;
}

.baloa-pro-stripe-payment-resume-modal__resume-item:first-of-type {
    margin-top: 0;
}

.baloa-pro-stripe-payment-resume-modal__resume-item .baloa-pro-stripe-payment-resume-modal__resume-item-title.baloa-names {
    color: var(--new-primary-very-dark-color);
    font-weight: var(--font-medium);
}

.baloa-pro-stripe-payment-resume-modal__resume-item .baloa-names {
    font-weight: var(--font-regular);
    color: var(--new-primary-very-dark-color);
}

.baloa-pro-stripe-payment-resume-modal__buttons {
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.baloa-pro-stripe-payment-resume-modal__buttons .button{
    margin-top: 43px;
    padding: 10px 20px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .baloa-pro-stripe-payment-resume-modal .modal__container {
        padding: 30px 12px;
        margin: 0 7px;
    }

    .baloa-pro-stripe-payment-resume-modal .modal__container__close {
        display: none;
    }

    .baloa-pro-stripe-payment-resume-modal .hubicon-check_circle {
        font-size: 40px;
    }

    .baloa-pro-stripe-payment-resume-modal__greetings.baloa-names,
    .baloa-pro-stripe-payment-resume-modal__message.baloa-names {
        margin-top: 24px;
    }

    .baloa-pro-stripe-payment-resume-modal__resume-container {
        margin-top: 24px;
    }

    .baloa-pro-stripe-payment-resume-modal__resume-item {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .baloa-pro-stripe-payment-resume-modal__resume-item .baloa-pro-stripe-payment-resume-modal__resume-item-title.baloa-names {
        margin-top: 0;
    }

    .baloa-pro-stripe-payment-resume-modal__resume-item .baloa-names {
        margin-top: 8px;
    }

    .baloa-pro-stripe-payment-resume-modal__buttons .button {
        margin-top: 24px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/baloa-pro/components/baloa-pro-stripe-payment-resume-modal/BaloaProStripePaymentResumeModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,gCAAgC;IAChC,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mDAAmD;IACnD,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,eAAe;IACf,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yCAAyC;IACzC,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;IAChC,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,2BAA2B;QAC3B,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".baloa-pro-stripe-payment-resume-modal .modal__container{\n    padding: 30px 40px;\n}\n\n.baloa-pro-stripe-payment-resume-modal {\n    text-align: center;\n}\n\n.baloa-pro-stripe-payment-resume-modal__container {\n    text-align: center;\n}\n\n.baloa-pro-stripe-payment-resume-modal .hubicon-check_circle {\n    font-size: 60px;\n}\n\n.baloa-pro-stripe-payment-resume-modal__title.baloa-headline-2{\n    color: var(--new-green-color);\n}\n\n.baloa-pro-stripe-payment-resume-modal__greetings.baloa-names,\n.baloa-pro-stripe-payment-resume-modal__message.baloa-names {\n    font-weight: var(--font-regular);\n    color: var(--new-primary-very-dark-color);\n    margin-top: 32px;\n}\n\n.baloa-pro-stripe-payment-resume-modal__resume-container {\n    border-radius: 8px;\n    border: 1px solid var( --new-gray-background-color);\n    margin-top: 43px;\n}\n\n.baloa-pro-stripe-payment-resume-modal__resume-container-title.baloa-names  {\n    background: var(--black-color);\n    color: var(--white-color);\n    border: inherit;\n    border-radius: 8px 8px 0 0;\n    padding: 8px 0;\n}\n\n.baloa-pro-stripe-payment-resume-modal__resume-container-items {\n    padding: 24px;\n}\n\n.baloa-pro-stripe-payment-resume-modal__resume-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 19px;\n}\n\n.baloa-pro-stripe-payment-resume-modal__resume-item:first-of-type {\n    margin-top: 0;\n}\n\n.baloa-pro-stripe-payment-resume-modal__resume-item .baloa-pro-stripe-payment-resume-modal__resume-item-title.baloa-names {\n    color: var(--new-primary-very-dark-color);\n    font-weight: var(--font-medium);\n}\n\n.baloa-pro-stripe-payment-resume-modal__resume-item .baloa-names {\n    font-weight: var(--font-regular);\n    color: var(--new-primary-very-dark-color);\n}\n\n.baloa-pro-stripe-payment-resume-modal__buttons {\n    width: 100%;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.baloa-pro-stripe-payment-resume-modal__buttons .button{\n    margin-top: 43px;\n    padding: 10px 20px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .baloa-pro-stripe-payment-resume-modal .modal__container {\n        padding: 30px 12px;\n        margin: 0 7px;\n    }\n\n    .baloa-pro-stripe-payment-resume-modal .modal__container__close {\n        display: none;\n    }\n\n    .baloa-pro-stripe-payment-resume-modal .hubicon-check_circle {\n        font-size: 40px;\n    }\n\n    .baloa-pro-stripe-payment-resume-modal__greetings.baloa-names,\n    .baloa-pro-stripe-payment-resume-modal__message.baloa-names {\n        margin-top: 24px;\n    }\n\n    .baloa-pro-stripe-payment-resume-modal__resume-container {\n        margin-top: 24px;\n    }\n\n    .baloa-pro-stripe-payment-resume-modal__resume-item {\n        flex-direction: column;\n        justify-content: flex-start;\n        align-items: flex-start;\n    }\n\n    .baloa-pro-stripe-payment-resume-modal__resume-item .baloa-pro-stripe-payment-resume-modal__resume-item-title.baloa-names {\n        margin-top: 0;\n    }\n\n    .baloa-pro-stripe-payment-resume-modal__resume-item .baloa-names {\n        margin-top: 8px;\n    }\n\n    .baloa-pro-stripe-payment-resume-modal__buttons .button {\n        margin-top: 24px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
